<script>
import moment from "moment";
import { MapClientType } from "@/common/util";

export default {
  props: {
    item: Object,
    trainingAt: String,
    trainingResult: Array
  },
  data() {
    let trainResult = {
      clientType: undefined,
      trainingAt: undefined,
      exitType: undefined
    };
    const mapType = {
      CLOSE_GAME_EXIT: "中途退出",
      NORMAL_GAME_OVER_EXIT: "结束退出",
      OTHER: "其他",
      LOADING_EXIT: "加载时退出",
      PLAYBACK_REBUILD_EXIT: "校验结束退出"
    };
    const mapPlayback = {
      RECORDING: "记录中",
      RECORDED: "记录完成",
      REBUILD: "完整",
      PART_LOSE_ERROR: "片段丢失",
      TITLE_LOSE_ERROR: "元数据丢失",
      ORIGIN_PART_LOSE: "元数据丢失",
      FIRST_PART_LOSE: "首片段丢失",
      MID_PART_LOSE: "回放不连续",
      LAST_PART_LOSE: "尾片段丢失",
      NO_PART: "无回放片段",
       TEST_PART: '测试游戏回放',
    };
    if (this.item.trainingState === "ENDED" && this.trainingResult.length > 0) {
      let filterRes = undefined;
      this.trainingResult.forEach(o => {
        if (o.trainingId === this.item.trainingId) {
          filterRes = o;
        }
      });
      if (filterRes) {
        trainResult = {
          clientType: MapClientType(filterRes.clientType),
          trainingAt: moment(filterRes.trainingAt).format("MM-DD HH:mm"),
          exitType: mapType[filterRes.exitType],
          playbackType: mapPlayback[filterRes.playbackState] || "--"
        };
      }
    }
    let percentage = 0;
    if (this.item.realTrainedDuration) {
      if (this.item.realTrainedDuration >= 600) {
        percentage = 100;
      } else {
        percentage = Math.floor((this.item.realTrainedDuration / 600) * 100);
      }
    }
    return {
      isDetails: false,
      gridData: [],
      tableTitle: [],
      trainingId: this.item.trainingId || null,
      percentage,
      totalTime: undefined,
      trainResult
    };
  },
  mounted() {
    console.log("patientTrainTrack", this.item);
  },
  methods: {
    async onClick() {
      let data = await this.$http.getGameDetileTable(this.item.trainingId);
      if (data && data.result) {
        let titleArr = [];
        let table = JSON.parse(data.result);
        if (table && table.length > 1) {
          this.gridData = table.slice(1);
          let title = JSON.parse(table[0].content);
          for (let key in title) {
            if (key && key !== "levelState") {
              titleArr.push([key, title[key]]);
            }
          }
          this.tableTitle = titleArr;
          let totalTime = 0;
          let scoreList =
            this.gridData &&
            this.gridData.map(o => (totalTime = totalTime + o.passTime));
          this.totalTime = totalTime;
        }
      }
    },
    close() {
      this.isDetails = false;
    },
    gameStart() {
      this.isDetails = true;
    },
    startReplay() {
      this.$router.push({
        path: `${this.$route.path}/${this.item.playbackId}/${this.item.gameResource.url}`
      });
      this.isDetails = false;
    }
  }
};
</script>

<template>
  <div class="container">
    <div v-if="item.trainingState === 'ENDED'">
      <div class="ReplayCell">
        <img class="replayMode" @click="gameStart" :src="item.gameResource.icon" />
        <div class="replayImgMode" @click="gameStart"></div>
        <img class="replayIcon" @click="gameStart" src="../../assets/视频回放.svg" />
        <p class="title">{{item.gameName}}</p>
        <p class="time">训练端：{{trainResult.clientType}}</p>
        <p class="time">开始时间：{{trainResult.trainingAt}}</p>
        <p class="time">退出方式：{{trainResult.exitType}}</p>
        <p class="time">回放状态：{{trainResult.playbackType}}</p>
        <el-progress
          class="progressBar"
          :percentage="percentage"
          :show-text="false"
          color="#BDE4EA"
          :stroke-width="8"
        ></el-progress>
        <div v-if="trainingId" class="dialogView">
          <el-popover placement="top" trigger="click" popper-class="popperClass">
            <div class="popperTotalTIme">本次闯关总时长：{{totalTime || '--'}}（秒）</div>
            <el-table
              :data="gridData"
              height="300"
              v-if="gridData.length > 0"
              class="popperClassTable"
            >
              <el-table-column
                v-for="item in tableTitle"
                :key="item[0]+ item[1]"
                min-width="60"
                :property="item[0]"
                :label="item[1]"
              ></el-table-column>
              <el-table-column width="100" property="levelState" label="闯关结果">
                <template slot-scope="scope">
                  <div v-if="scope.row.levelState === 'success'">
                    <span class="winSuccess">
                      成功
                      <i class="el-icon-success"></i>
                    </span>
                  </div>
                  <div v-else-if="scope.row.levelState === 'fail'">
                    <span class="winFailed">
                      失败
                      <i class="el-icon-error"></i>
                    </span>
                  </div>
                  <div v-else>
                    <span>未完成</span>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <span v-else class="noDataView">暂无数据</span>
            <el-button slot="reference" type="text" @click="onClick">...</el-button>
          </el-popover>
        </div>
        <span class="gameRateStar">
          评估值：
          <span v-if="item.quality && item.quality >= 25">{{item.quality}}</span>
          <span
            v-else-if="item.quality && item.quality >= 10"
            style="color: #FFB200"
          >{{item.quality}}</span>
          <span
            v-else-if="item.quality && item.quality < 10"
            style="color: #FF0000"
          >{{item.quality}}</span>
          <span style="color: #FF0000" v-else-if="item.quality== 0">{{item.quality}}</span>
          <span v-else>--</span>
        </span>
        <!-- <gameRateStar  :score="item.score" /> -->
      </div>
      <Dialog title="回放" v-if="isDetails" @close="close" btn-text="开始回放" @confirm="startReplay"></Dialog>
    </div>
    <div v-else-if="item.trainingState === 'STARTED'" class="unTrain">
      <div class="pending">{{item.gameName}}</div>
      <div class="pendingBottom">训练中</div>
    </div>
    <div v-else class="unTrain">
      <div class="pending">{{item.gameName}}</div>
      <div class="pendingBottom">未训练</div>
    </div>
  </div>
</template>

<style lang="scss">
.popperClass {
  max-height: 50%;
  min-width: 40%;
  min-height: 200px;
  max-width: 80%;
  position: fixed;
  top: 50% !important;
  left: 50% !important;
  transform: translateX(-50%) translateY(-50%);
  .noDataView {
    text-align: center;
    display: inline-block;
    width: 100%;
    margin-top: 100px;
  }
  .popperClassTable {
    .cell {
      padding-right: 0px !important;
      padding-left: 0px !important;
    }
  }
  .popperTotalTIme {
  }
  .winSuccess {
    > i {
      color: #67c23a;
      padding-left: 5px;
    }
  }
  .winFailed {
    color: red;
    > i {
      padding-left: 5px;
    }
  }
}
</style>
<style lang="scss" scoped>
.container {
  width: 175px;
  height: 260px;
  margin: 10px;
  display: inline-block;
  .pending {
    margin-top: 40%;
    color: #dedede;
    font-size: 14px;
    text-align: center;
  }
  .pendingBottom {
    color: #dedede;
    font-size: 14px;
    text-align: center;
    margin-top: 8px;
  }
}
.unTrain {
  // border: 1px solid #e9e9e9;
  display: inline-block;
  position: relative;
  width: 175px;
  height: 260px;
  background: rgba(255, 255, 255, 1);
  border-radius: 2px;
  border: 1px solid rgba(233, 233, 233, 1);
  box-sizing: border-box;
}
.dialogView {
  float: right;
  margin-bottom: 5px;
  margin-right: 5px;
  margin-top: -15px;
}
.Dialog {
  position: relative;
  .pointBox {
    position: absolute;
    left: 30px;
  }
  .circle {
    width: 8px;
    height: 8px;
    display: inline-block;
    background: #db969e;
    border-radius: 50%;
  }
  h3 {
    position: absolute;
    margin: 0 30px;
    width: 80px;
    height: 21px;
    font-size: 16px;
    color: rgba(52, 52, 52, 1);
    line-height: 21px;
  }
  .topH {
    top: 30px;
    color: #3ca8f5;
  }
  .topP {
    margin: 0 30px;
    width: 289px;
    font-size: 14px;
    color: #3ca8f5;
    line-height: 19px;
  }
  .line {
    margin: 15px 30px 13px 30px;
    width: 289px;
    border: 1px solid rgba(235, 235, 235, 1);
  }
  .middleImg {
    position: absolute;
    left: 114px;
  }
  .listImg {
    position: absolute;
    left: 30px;
    top: 171px;
    display: block;
    width: 8px;
    height: 8px;
    overflow: hidden;
  }
  .bottomDiv {
    margin: 50px 16px 25px 44px;
    font-size: 14px;
    color: rgba(120, 120, 120, 1);
    line-height: 19px;
  }
}

.ReplayCell {
  display: inline-block;
  position: relative;
  width: 175px;
  height: 260px;
  background: rgba(255, 255, 255, 1);
  border-radius: 2px;
  border: 1px solid rgba(233, 233, 233, 1);
  box-sizing: border-box;
  cursor: pointer;
  > p {
    margin-left: 17px;
    margin-right: 17px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  img {
    width: 100%;
    height: 105px;
  }
  .title {
    height: 24px;
    text-align: center;
    margin-top: 8px;
    margin-bottom: 2px;
    font-size: 16px;
    color: #00c1de;
  }
  .desc {
    color: rgba(0, 0, 0, 0.45);
  }
  .time {
    font-size: 12px;
    padding-left: 12px;
    color: rgba(0, 0, 0, 0.45);
    margin: 5px 0;
  }
  .progressBar {
    padding: 3px 12px 0 12px;
    margin: 5px 0;
  }
  .gameRateStar {
    padding: 0 12px;
    display: inline-block;
  }
  .replayIcon {
    position: relative;
    float: left;
    width: 35px;
    height: 35px;
    margin-top: -75px;
    margin-left: 70px;
  }
  .replayImgMode {
    position: absolute;
    top: 0;
    left: -2px;
    width: 101%;
    height: 105px;
    opacity: 0.6;
    background-color: #000000 !important;
  }
}
.ReplayCell:hover p {
  color: #3ca8f5;
}
</style>





// WEBPACK FOOTER //
// src/components/visionTrainTrack/ReplayCell.vue